import React, { Component } from "react";
import styles from "./Tools.module.css";

export class AddressToScripthash extends Component {
  constructor(props) {
    super(props);
    this.state = { address: "", scriptHash: "" };
  }

  generateScriptHash = async () => {
    try {
        const resp = await fetch("util/scripthash?address=" + this.state.address);
        const result = await resp.text();
        this.setState({ scriptHash: result });
    } catch (error) {
        console.log(`Error: ${error.message}`);
    }
  };

  render() {
    return (
        <div className={`${styles.tools} times mbox`}>
            <h4 className="text-center" title="Convert Bitcoin Address (P2WPKH, P2PKH) to ScriptHash (big endian) for API client">
            <i className="bi bi-box-arrow-right" style={{ color: "brown" }}></i>{" "}
            Convert Address to ScriptHash
            </h4>
            <hr />
                <table width="100%">
                    <tbody>
                    <tr style={{ height: 70 }}>
                    <td>
                        <div className={`${styles.enterHex}`}>Enter Address: </div>
                        <div width="100%">
                        <input
                            type="text"
                            id="address"
                            value={this.state.address}
                            onChange={(e) => this.setState({ address: e.target.value })}
                            style={{ width: "100%", padding: "8px", marginTop: "3px" }}
                            placeholder="Enter Bitcoin address (P2PKH, P2WPKH))"
                            />
                        </div>
                    </td>
                    </tr>
                    <tr>
                        <td>
                            <div>
                                <button className="btn btn-primary" style={{ width: "120px"}} title="Convert Address to ScriptHash (aka ScriptPubkeyHash)." onClick={this.generateScriptHash}>Convert</button>
                            </div>
                        </td>
                    </tr>
                    <tr style={{ height: 70 }}>
                    <td>
                        <div className="label">ScriptHash (for API client): </div>
                        <div width="100%">
                        <input
                            id="scriptPubKeyHash"
                            readOnly={true}
                            type="text"
                            style={{ width: "100%", padding: "8px", marginTop: "3px", backgroundColor: "lightgray"}}
                            value={this.state.scriptHash}
                            />
                        </div>
                    </td>
                    </tr>
                    </tbody>
                </table>
        </div>
    );
 }
};

